// removed by extract-text-webpack-plugin
module.exports = {"button":"_24aQFV46uT5-LMFV0nKCMy","left":"zIGvV2xdCHatCOr26yOPg","right":"_3HkG_uK-eEV8haBSJV2Kjl","boxContainer":"_2gGIXwem2Gf4NIyeHy3Ltg","blue":"_2oTnNI-i1RP_cnnjykZ0q1","red":"_2RYKv8Rb1WLE5JQE1DN_q7"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/actions/Button.css
// module id = 293
// module chunks = 0